import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

const PLAY_KEY = "baobab.play";
export const playState = {
  get: () => JSON.parse(localStorage.getItem(PLAY_KEY) || "{}"),
  set: (patch) => localStorage.setItem(PLAY_KEY, JSON.stringify({ ...playState.get(), ...patch })),
  clear: () => localStorage.removeItem(PLAY_KEY),
};

export const SIDE_FR = { left: "Gauche", right: "Droit", bilateral: "Bilatéral" };
export const LIMB_FR = { left_arm: "Bras gauche", right_arm: "Bras droit", left_leg: "Jambe gauche", right_leg: "Jambe droite" };
export const MODE_FR = { assisted: "Assisté", rehabilitation: "Rééducation", challenge: "Défi" };
export const STATUS_FR = { planned: "Planifiée", in_progress: "En cours", completed: "Terminée", stopped: "Interrompue" };
export const LEVEL_FR = { mild: "Légère", moderate: "Modérée", severe: "Sévère", none: "Aucune", good: "Bon", poor: "Faible" };

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" }) : "—";
export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—";
export const fmt = (v, unit = "") => (v === null || v === undefined ? "—" : `${v}${unit}`);
